import { useMemo } from 'react';

import { useAuth } from '@/lib/auth/AuthContext';
import { useEnvStore } from '@/lib/store/envStore';

import { ApiClient } from './client';

/**
 * Stable ApiClient bound to:
 *  - current Keycloak access token (captured by ref so refreshes propagate)
 *  - current Test/Live env from the EnvSwitcher (sent as X-Console-Env)
 */
export function useApiClient(): ApiClient {
    const { getAccessToken } = useAuth();
    const env = useEnvStore((state) => state.env);
    return useMemo(
        () =>
            new ApiClient({
                getToken: getAccessToken,
                getEnvHeader: () => env.toUpperCase(),
            }),
        [getAccessToken, env],
    );
}
